







































/**
 * 城市选择页面
 */
import { defineComponent, ref, onMounted } from "@vue/composition-api";
import { useMainStore } from "@/store/main";
import { getAllCityBySort, CityItem } from "@/api/land";

type CityIndexObj = {
  [key: string]: CityItem[];
};
export default defineComponent({
  emits: ["back", "choose"],
  setup(_, { emit }) {
    const cityName = ref<string>("");
    const citys = ref<CityIndexObj>({});
    const getAllCity = async () => {
      const [err, res] = await getAllCityBySort({ name: cityName.value });
      if (!err && res != undefined) {
        let tmp: CityIndexObj = {};
        res.forEach((item) => {
          if (!tmp.hasOwnProperty(item.initialPy)) {
            tmp[item.initialPy] = [
              {
                name: item.name,
                latitude: item.latitude,
                longitude: item.longitude,
                initialPy: item.initialPy,
              },
            ];
          } else {
            tmp[item.initialPy].push({
              name: item.name,
              latitude: item.latitude,
              longitude: item.longitude,
              initialPy: item.initialPy,
            });
          }
        });
        citys.value = { ...tmp };
      }
    };

    const handleSearch = () => {
      getAllCity();
    };
    const handleChoose = (item: CityItem) => {
      emit("choose", item);
    };
    onMounted(() => {
      getAllCity();
    });

    return {
      citys,
      cityName,
      handleSearch,
      handleChoose,
      mainStore: useMainStore(),
    };
  },
});
